import React from "react";

export default function DialogsIcon({ fill }) {
  return (
    // <svg
    // 	width='33'
    // 	height='30'
    // 	viewBox='0 0 33 30'
    // 	fill='none'
    // 	xmlns='http://www.w3.org/2000/svg'
    // >
    // 	<path
    // 		d='M29.1875 9.6875C31.1699 9.6875 32.8125 11.3301 32.8125 13.3125V22.375C32.8125 24.4141 31.1699 26 29.1875 26H27.375V28.9453C27.375 29.3984 27.0352 29.625 26.6953 29.625C26.5254 29.625 26.4121 29.625 26.2422 29.5117L20.125 26H14.6875C12.6484 26 11.0625 24.4141 11.0625 22.375V18.0137L6.70117 20.4492C6.53125 20.5625 6.41797 20.5625 6.30469 20.5625C5.9082 20.5625 5.625 20.3359 5.625 19.8828V16.9375H3.8125C1.77344 16.9375 0.1875 15.3516 0.1875 13.3125V4.25C0.1875 2.26758 1.77344 0.625 3.8125 0.625H20.125C22.1074 0.625 23.75 2.26758 23.75 4.25V9.6875H29.1875ZM3.8125 15.125H7.4375V17.957L11.9688 15.4082L12.3652 15.125H20.125C21.0879 15.125 21.9375 14.332 21.9375 13.3125V4.25C21.9375 3.28711 21.0879 2.4375 20.125 2.4375H3.8125C2.79297 2.4375 2 3.28711 2 4.25V13.3125C2 14.332 2.79297 15.125 3.8125 15.125ZM31 22.375V13.3125C31 12.3496 30.1504 11.5 29.1875 11.5H23.75V13.3125C23.75 15.3516 22.1074 16.9375 20.125 16.9375H12.875V22.375C12.875 23.3945 13.668 24.1875 14.6875 24.1875H20.5781L20.9746 24.4707L25.5625 27.0195V24.1875H29.1875C30.1504 24.1875 31 23.3945 31 22.375Z'
    // 		fill='#575757'
    // 	/>
    // </svg>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00004 9.33333C7.00004 8.689 7.52238 8.16667 8.16671 8.16667H19.8334C20.4777 8.16667 21 8.689 21 9.33333C21 9.97767 20.4777 10.5 19.8334 10.5H8.16671C7.52238 10.5 7.00004 9.97767 7.00004 9.33333Z"
        fill={fill ? fill : "#6E6E73"}
      />
      <path
        d="M8.16671 12.8333C7.52238 12.8333 7.00004 13.3557 7.00004 14C7.00004 14.6443 7.52238 15.1667 8.16671 15.1667H12.8334C13.4777 15.1667 14 14.6443 14 14C14 13.3557 13.4777 12.8333 12.8334 12.8333H8.16671Z"
        fill={fill ? fill : "#6E6E73"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 19.8333H23.3334C24.622 19.8333 25.6667 18.7887 25.6667 17.5V5.83333C25.6667 4.54467 24.622 3.5 23.3334 3.5H4.66671C3.37804 3.5 2.33337 4.54467 2.33337 5.83333V17.5C2.33337 18.7887 3.37804 19.8333 4.66671 19.8333H14V22.1667C14 24.409 16.8546 25.3606 18.2 23.5667L21 19.8333ZM16.3334 17.5V22.1667L19.8334 17.5H23.3334V5.83333H4.66671V17.5H16.3334Z"
        fill={fill ? fill : "#6E6E73"}
      />
    </svg>
  );
}
